import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { AppRoutes } from "pages/constants/routes";
import Home from "pages/Home";
import SignIn from "pages/SignIn";
import SignUp from "pages/SignUp";
import ResetPasswordRequest from "pages/ResetPasswordRequest";
import ResetPassword from "pages/ResetPassword";
import Support from "pages/Support";
import Settings from "pages/Settings";
import NewProject from "pages/NewProject";
import Project from "pages/Project";
import UserService from "api/User/UserService";
import Credit from "pages/Credit";
import Admin from "pages/Admin";
import AuthWrapper from "components/AuthWrapper";
import { RootState } from "store";
import { logout, setUser, UserState } from "store/userSlice";

const App = () => {
  const dispatch = useDispatch();
  const userState: UserState = useSelector((state: RootState) => state.user);

  const getSelf = useCallback(async () => {
    try {
      const response = await UserService.getSelf();
      dispatch(
        setUser({
          loggedIn: true,
          username: response.username,
          email: response.email,
          hasPrivilegedAccess: response.has_privileged_access,
        }),
      );
    } catch (err) {
      dispatch(logout());
    }
  }, [dispatch]);

  useEffect(() => {
    getSelf();
  }, [userState.loggedIn, getSelf]);

  return (
    <Router>
      <Routes>
        <Route path={AppRoutes.support} element={<Support />} />
        {!userState.loggedIn && (
          <>
            {/* <Route index element={<Landing />} /> */}
            <Route index element={<SignIn />} />
            <Route path={AppRoutes.signin} element={<SignIn />} />
            <Route path={AppRoutes.signup} element={<SignUp />} />
            <Route
              path={AppRoutes.resetPasswordRequest}
              element={<ResetPasswordRequest />}
            />
            <Route path={AppRoutes.resetPassword} element={<ResetPassword />} />
          </>
        )}
        {userState.loggedIn && (
          <Route element={<AuthWrapper />}>
            <Route index element={<Home />} />
            <Route path={AppRoutes.settings} element={<Settings />} />
            <Route path={AppRoutes.newProject} element={<NewProject />} />
            <Route path={AppRoutes.project + "/*"} element={<Project />} />
            <Route path={AppRoutes.credit} element={<Credit />} />
            <Route path={AppRoutes.admin} element={<Admin />} />
          </Route>
        )}
        <Route
          path="*"
          element={
            <Navigate to={AppRoutes.landing} replace={true} />
          } /* Redirects to landing / home page based on login status */
        />
      </Routes>
    </Router>
  );
};

export default App;
